var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showLocation
        ? _c(
            "v-card",
            { attrs: { id: "vCardDialogVideo", shaped: "", outlined: "" } },
            [
              _c("div", { attrs: { id: "headerDialogVideo" } }, [
                _c("div", { staticStyle: { "margin-left": "2%" } }, [
                  _c("h2", { staticClass: "textstyle" }, [
                    _vm._v("Última Ubicación")
                  ])
                ])
              ]),
              _c("div", { attrs: { id: "bodyDialogVideo" } }, [
                _c("div", {
                  staticClass: "google-map",
                  attrs: { id: _vm.mapName }
                })
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }